import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Button,
  Label,
  UncontrolledTooltip,
  Input,
  FormFeedback
} from "reactstrap";
import Select from 'react-select';

// Redux
import { Link } from "react-router-dom";
import { getClientFullList, postTicketCreate } from "connection/backend";

// Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

// Import components
import ClientCard from "pages/Dashboard/Tickets/Card"
import SummaryModal from "pages/Dashboard/Tickets/Modal1";
import SweetAlert from "react-bootstrap-sweetalert";

const TicketCreate = () => {
  const URL = process.env.REACT_APP_API_URL;
  const [alert, setAlert] = useState(false);
  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [clients, setClients] = useState([]);

  const [formData, setFormData] = useState({
    client_code: "",
    animal_number: "",
  });
  const { client_code, animal_number } = formData;

  const [ticketCreated, setTicketCreated] = useState({});

  useEffect(() => {
    getClientList();
  }, []);

  const getClientList = async () => {
    setLoading(true);
    const response = await getClientFullList();
    setClients(response.data);
    setLoading(false);
  };

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onClientChange = (selectedOption) => {
    setFormData({ ...formData, client_code: selectedOption ? selectedOption.value : "" });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    postTicket({
      client_code: client_code,
      animal_number: parseInt(animal_number),
    });
  };

  const postTicket = async (data) => {
    setLoading(true);
    const response = await postTicketCreate(data);
    if (response.status === 201) {
      setTicketCreated(response.data);
      setAlert(true);
    } else {
      setError(response.data);
    }
    setLoading(false);
  };

  const clientOptions = clients.map(client => ({
    value: client.code,
    label: `${client.code} - ${client.full_name}`,
  }));

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '48px', // Set the minimum height
      height: '48px', // Set the fixed height
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '48px', // Match the height
      padding: '0 6px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '48px', // Match the height
    }),
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Tickets </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Tickets"} />
          {loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              <Card
                style={{
                  width: "85rem",
                }}
              >
                <CardBody>
                  <Row className="d-flex justify-content-center">
                    {client_code && (
                      <ClientCard code={client_code} />
                    )}
                    <Col lg={6} className="d-flex flex-column justify-content-center">
                      <Card style={{ border: 'none' }}>
                        <CardBody>
                          <Form onSubmit={onSubmit}>
                            <Row className="justify-content-md-center">
                              <Col lg={10}>
                                <p>Registrar entrada de ganado</p>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center mb-4">
                              <Col lg={8}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bxs-contact bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Select
                                      options={clientOptions}
                                      value={clientOptions.find(option => option.value === client_code)}
                                      onChange={onClientChange}
                                      placeholder="Cliente"
                                      isClearable
                                      classNamePrefix="react-select"
                                      name="client_code"
                                      id="client_code"
                                      styles={customStyles}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col lg={2}>
                                <Row>
                                  <Col lg={3} className="pt-3">
                                    <Link to="/clients/create">
                                      <span
                                        className="bx bx-plus-circle bx-sm"
                                        id="client_add"
                                      ></span>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="client_add"
                                      >
                                        Agregar nuevo cliente
                                      </UncontrolledTooltip>
                                    </Link>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center">
                              <Col lg={6}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bx-spreadsheet bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Input
                                      type="number"
                                      className="form-control"
                                      placeholder="Número de bovinos"
                                      name="animal_number"
                                      id="animal_number"
                                      value={animal_number}
                                      min={1}
                                      onChange={onChange}
                                      {...(error.animal_number && {
                                        ...(error.animal_number
                                          ? { invalid: true }
                                          : { valid: true }),
                                      })}
                                      required
                                    />
                                    <FormFeedback tooltip>
                                      {error.animal_number}
                                    </FormFeedback>
                                    <Label for="animal_number">Número de bovinos</Label>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center mt-4 ms-0">
                              <Col lg={5}>
                                <Link className="btn btn-danger me-4" to="/tickets">
                                  Volver
                                </Link>

                                <Button color="success" type="submit">
                                  Registrar
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          )}
          {/* Alert */}
          <SweetAlert
            title="¡Hecho!"
            success
            showConfirm={true}
            show={alert}
            onConfirm={() => {
              setAlert(false);
              toggle1();
            }}
          >
            El ticket se registró correctamente.
          </SweetAlert>
          {/* Modals */}
          {modal1 && <SummaryModal isOpen={modal1} toggle={toggle1} ticketData={ticketCreated} />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TicketCreate;
